import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import {AutocompleteRenderGroupParams} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import { CollapseHeader, CollapseText } from './CollapseGroup.styles';

export const CollapseGroup = (params: AutocompleteRenderGroupParams) => {
    const [open, setOpen] = React.useState(false);

    return (
        <Box>
            <CollapseHeader onClick={() => setOpen(!open)}>
                <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpen(!open)}
                >
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>{" "}
                <CollapseText>
                    {params.group}
                </CollapseText>
            </CollapseHeader>
            <Collapse in={open} timeout="auto">
                {params.children}
            </Collapse>
        </Box>
    );
};